








import { Component, Vue, Watch } from "vue-property-decorator";
import { startOfMonth, endOfMonth } from "date-fns";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";

import ShiftModal from "./ShiftModal.vue";
import shiftModel from "@/models/shift.model";

@Component({
	name: "users",
	components: {
		ShiftFilter,
		PaginatedSearch,
		ShiftModal,
	},
})
export default class ShiftsReport extends Vue {
	shiftModel: any;
	shiftFilter = {};
	shiftId: any = null;

	constructor() {
		super();
		this.shiftModel = shiftModel;
	}

	updateFilter(filter: any)  {
		this.shiftFilter = filter;
	}
}
